// ReplayGuard (ТЗ §5.10) — полностью отключает PostHog session replay на
// routes с user-content (конспекты, чат-тьютор, эссе, запись лекции,
// визуальный объяснитель, voice). На остальных — replay включён (sampling
// настраивается в PostHog Project settings, 10%).
//
// Монтируется внутри router-дерева (useRouterState доступен только под
// RouterProvider) — в __root.tsx рядом с <Outlet/>. Возвращает null.
import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { setSessionRecording } from "./posthog-client";

const NO_REPLAY_ROUTES = [
	"/notes",
	"/tutor",
	"/essays",
	"/lecture",
	"/recordings",
	"/visual",
	"/voice",
];

export function ReplayGuard(): null {
	const pathname = useRouterState({ select: (s) => s.location.pathname });
	useEffect(() => {
		const sensitive = NO_REPLAY_ROUTES.some((r) => pathname.startsWith(r));
		setSessionRecording(!sensitive);
	}, [pathname]);
	return null;
}
